import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MasterDataManagementService } from '@service/master-data-management/master-data-management.service';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  NoRedirectionNotifyTypeEnum,
  NotifyTypeIncludesEnum,
} from 'src/app/shared/enum/notify-type-includes.enum';
import { AutenticationService } from 'src/app/shared/service/autentication/autentication.service';
import { GlobalService } from 'src/app/shared/service/global/global.service';
import { environment } from 'src/environments/environment';
import { notificationNavigateDetails } from '../config/notification-navigate-details.config';
import { FirebaseService } from './../../../../shared/service/firebase/firebase.service';
@Component({
  selector: 'app-notification-main',
  templateUrl: './notification-main.component.html',
  styleUrls: ['./notification-main.component.css'],
})
export class NotificationMainComponent implements OnInit, OnDestroy {
  message: any;
  unregisterModel = {
    user_id: '',
    device_id: '',
  };
  registerModel = {
    user_id: '',
    device_id: '',
    reg_token: '',
    device: '',
    type: '',
  };
  deviceInfo: import('ngx-device-detector').DeviceInfo;
  sessionUser: any;
  notificationList: any = [];
  cohortDatasource: any = [];
  programId: string;
  unsubscribe$: Subject<boolean> = new Subject();

  constructor(
    public firebaseService: FirebaseService,
    public autenticationService: AutenticationService,
    private deviceService: DeviceDetectorService,
    public globalService: GlobalService,
    public router: Router,
    public masterDataService: MasterDataManagementService
  ) {
    this.sessionUser = this.autenticationService.getSessionUser();
  }

  ngOnInit(): void {
     this.requestPermission();
    this.listen();

    this.deviceInfo = this.deviceService.getDeviceInfo();
    // const isMobile = this.deviceService.isMobile();
    // const isTablet = this.deviceService.isTablet();
    // const isDesktopDevice = this.deviceService.isDesktop();
    //console.log(this.deviceInfo);
    this.programId = localStorage.getItem('current_selected_program');
    if (this.programId) this.getCohortListByProgramID(this.programId);
    // this.getAllNotificationByUser(this.sessionUser.user_id, '');

    this.firebaseService
      .getNotificationLoad()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result == true) {
          //console.log(result);
          this.notificationList = [];
          this.programId = localStorage.getItem('current_selected_program');
          if (this.programId) this.getCohortListByProgramID(this.programId);
        }
      });
  }

  ngOnDestroy() {
    this.unRegisterNotificationServer();
  }

  requestPermission() {
    const messaging = getMessaging();
    getToken(messaging, { vapidKey: environment.firebase.vapidKey })
      .then((currentToken) => {
        if (currentToken) {
          //console.log('Hurraaa!!! we got the token.....');

          //console.log(currentToken);
          this.registerNotificationServer(currentToken);
        } else {
          // console.log(
          //   'No registration token available. Request permission to generate one.'
          // );
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
  }

  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      this.message = payload.data;
      this.message.data = JSON.parse(this.message.data);
      this.message.isRedirectionRequired = true;
      this.message.is_seen = false;
      this.message.created_at = new Date();
      this.globalService.showSwalWithToast_notification('             ', this.message.data.message, 'info', true, 5000, false, true);
      this.notificationList.unshift(this.message); 
      this.firebaseService.setNotificationListLoadObs(this.notificationList);
      //this.getAllNotificationByUser(this.sessionUser.user_id);
    });
  }

  registerNotificationServer(regFirebaseToken: any) {
    this.registerModel.reg_token = regFirebaseToken;
    this.registerModel.device = this.deviceInfo.userAgent;
    this.registerModel.device_id = this.deviceInfo.userAgent;
    this.registerModel.user_id = this.sessionUser.user_id;
    this.registerModel.type = this.deviceInfo.deviceType;
    this.firebaseService.registerNotification(this.registerModel).subscribe(
      (result) => {
        //console.log(result);
        // if (result.status == 'ok') {
        //   console.log('register done to notification server.');
        // }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  unRegisterNotificationServer() {
    //console.log(navigator.mediaDevices.enumerateDevices());
    //console.log(navigator.mediaDevices);

    this.unregisterModel.user_id = this.sessionUser.user_id;
    this.unregisterModel.device_id = this.deviceInfo.userAgent;

    this.firebaseService.unregisterNotification(this.unregisterModel).subscribe(
      (result) => {
        //console.log(result);
        if (result.status == 'ok') {
          //console.log('Unregister from notification server.');
          this.notificationList = [];
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getAllNotificationByUser(user_id) {
    if (this.cohortDatasource.length > 0) {
      this.cohortDatasource.forEach((cohort) => {
        this.firebaseService
          .getAllNotificationByUser(user_id, cohort.id)
          .subscribe(
            (result) => {
              if (result.status == 'ok') {
                if (result.resultset.length > 0) {
                  this.notificationList = result?.resultset ?? [];
                  this.notificationList.forEach((element) => {
                    element.data = JSON.parse(element.data);
                    element.isRedirectionRequired = true ;//this.isRequiredRedirection(element);
                  });
                  // Sort by Notify Type
                  this.notificationList = this.notificationList.sort(
                    this.globalService.dynamicSort('notify_type')
                  );
                  // Then sort by created Date Desc.
                  this.notificationList = this.notificationList.sort(function (
                    a,
                    b
                  ) {
                    const c: any = new Date(a.created_at);
                    const d: any = new Date(b.created_at);
                    return d - c;
                  });

                  this.firebaseService.setNotificationListLoadObs(this.notificationList);

                  console.log(this.notificationList);
                }
              }
            },
            (err) => {
              console.log(err);
            }
          );
      });
    } else {
      // console.warn(
      //   'No Cohort Found with selected program. So No notification found.'
      // );
    }
  }

  async getCohortListByProgramID(programID) {
    (
      await this.masterDataService.getCohortListByProgramID(programID)
    ).subscribe(
      (result) => {
        if (result.status == 'ok') {
          this.cohortDatasource = result.resultset.filter(
            (data) => data?.is_active === true
          );
          //console.log(this.cohortDatasource);

          this.getAllNotificationByUser(this.sessionUser.user_id);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  isRequiredRedirection(notification: any) {
    const notifyType = notification?.notify_type?.toLowerCase();

    for (const key in NoRedirectionNotifyTypeEnum) {
      if (notifyType?.includes(NoRedirectionNotifyTypeEnum[key])) return false;
    }

    return true;
  }

  detailsPage(notification: any) {
    if (!notification.isRedirectionRequired) return;

    const waitingForMyApprovalBaseUrl =
      'dashboard/approval/waiting-for-my-approval';

    const notifyType = notification?.notify_type?.toLowerCase();
    if (notifyType?.includes(NotifyTypeIncludesEnum.MEAL)) {
      this.mealDetailsPage(notification?.data?.finding, 'edit');
      this.seenNotification(notification);
    } else {
       for (const key in NotifyTypeIncludesEnum) {
      if (notifyType?.includes(NotifyTypeIncludesEnum[key])) {
        const notificationNavigate =
          notificationNavigateDetails[NotifyTypeIncludesEnum[key]];

        this.router.navigateByUrl(
          `${waitingForMyApprovalBaseUrl}/${notificationNavigate.url}?${
            notificationNavigate.queryParamsKey[0]
          }=${notification?.data?.[notificationNavigate.idKey]}`
        );

        break;
      }
    }
    }
   
  }

  mealDetailsPage(data, mode) {
     const url = this.router.serializeUrl(
      this.router.createUrlTree(
        ['dashboard/meal-department/meal-findings/summary-report'],
        {
          queryParams: {
            cohort_id: data?.cohort_id,
            branch_id: data?.branch_id,
            finding_id: data?.id,
            category_type: data?.category_type,
            mode: mode,
          },
        }
      )
    );
    window.open(url, '_blank');
  }

  seenNotification(notification) {
     
    if (notification.is_seen == false) {
      this.firebaseService.updateIsSeenNotification(this.sessionUser.user_id, notification.notification_id).subscribe(
        (result) => {
          if (result.status == 'ok') {
            notification.is_seen = true;
            this.firebaseService.setNotificationListLoadObs(this.notificationList);
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  }
}
